
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { Container } from "../../../components/util/container";
import { Section } from "../../../components/util/section";
import Posts from "../../../components/blog/BlogPosts";
import Header from "../../../components/blog/Header";
import { client } from "../../../../tina/__generated__/client";
import useTranslation from "next-translate/useTranslation";
export default function Category({ category, posts }) {
    const { t } = useTranslation("common");
    if (!category) {
        return null;
    }
    return (<Section className="flex-1">
      <Header>
        <h2 className="relative w-full mb-4 text-3xl font-extrabold tracking-normal text-center text-white md:text-5xl title-font">
          {t(category.category)}
        </h2>
        <div className="max-w-2xl mx-auto text-sm font-normal text-center text-gray-300 md:text-base">
          {category.description}
        </div>
      </Header>
      <Container size="medium" width="small">
        {posts.length > 0 ? (<Posts data={posts} groupBySubtopic mode="guides"/>) : (<div className="px-6 py-8 mt-10 text-sm text-gray-600 bg-white border border-slate-200 rounded-xl">
            New guides for this topic are coming soon.
          </div>)}
      </Container>
    </Section>);
}
export const getStaticPaths = async () => {
    const categoryConnection = await client.queries.categoryConnection();
    const categories = categoryConnection.data.categoryConnection.edges;
    const basePaths = categories
        .filter((category) => category.node._sys.filename !== "news")
        .map((category) => {
        return {
            params: {
                filename: category.node._sys.filename,
            },
        };
    });
    const paths = basePaths.map((path) => ({ ...path, locale: "en" }));
    return {
        paths,
        fallback: true,
    };
};
const getStaticProps = async ({ params }) => {
    const { filename } = params;
    if (filename === "news") {
        return {
            redirect: {
                destination: "/news",
                permanent: true,
            },
        };
    }
    const postsResponse = await client.queries.postConnection({
        filter: {
            locale: { eq: "en" },
            category: {
                category: {
                    slug: { eq: filename },
                },
            },
        },
    });
    const posts = postsResponse.data.postConnection.edges;
    const variables = {
        relativePath: `${filename}.md`,
    };
    const props = await client.queries.category(variables);
    const category = props.data.category;
    if (!category) {
        return {
            notFound: true,
        };
    }
    return {
        props: {
            posts,
            category,
        },
    };
};

    async function __Next_Translate__getStaticProps__1a042aa3e54__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/guides/category/[filename]',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a042aa3e54__ as getStaticProps }
  